module.exports = __webpack_public_path__ + "media/notification_3.34b5ccfa.wav";